import { useEffect, useState } from "react";
import axiosClient from "../../../../utils/api/axiosClient";
import { getToken } from "../../../../utils/functions";
import FormModel from "./models/FormModel";

export interface IPaadham {
  id: number;
  name: string;
  isActive: boolean;
}

export const initialFormData: IPaadham = {
  id: 0,
  name: "",
  isActive: false,
};

function Paadham() {
  const [paadhams, setPaadhams] = useState<IPaadham[]>([]);
  const [initial, setInitial] = useState<IPaadham>(initialFormData);
  useEffect(() => {
    const headers = { Authorization: getToken() };
    axiosClient.get("v1/paadham", { headers }).then((res) => {
      if (res.status === 200) setPaadhams(res.data);
    });
  }, []);

  const handleDelete = (id: number) => {
    const headers = { Authorization: getToken() };
    axiosClient.delete("v1/paadham/" + id, { headers }).then((res) => {
      if (res.status === 200) setPaadhams(res.data);
    });
  };

  const handleEdit = (state: IPaadham) => {
    setInitial(state);
    setModalShow(true);
  };

  const handleCreate = () => {
    setInitial(initialFormData);
    setModalShow(true);
  };

  const [modalShow, setModalShow] = useState(false);

  return (
    <div className="app-content pt-3 p-md-3 p-lg-4">
      <div className="container-xl">
        <h1 className="app-page-title">Paadham</h1>
        <div className="row">
          <div className=" col-lg-12 ">
            <div className="card">
              <div className="card-header gutters-5">
                <h5 className="mb-md-0 h6">
                  All Paadham
                  <i
                    onClick={handleCreate}
                    className="fa fa-plus btn btn-sm pull-right"
                  ></i>
                </h5>
              </div>
              <div className="card-body">
                <table className="table aiz-table mb-0 footable footable-1 breakpoint-lg">
                  <thead>
                    <tr className="footable-header">
                      <th style={{ display: "table-cell" }}>#</th>
                      <th style={{ display: "table-cell" }}>Name</th>
                      <th style={{ display: "table-cell" }}>IsActives</th>
                      <th
                        className="text-right"
                        style={{ display: "table-cell", width: "20%" }}
                      >
                        Options
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {paadhams.length ? (
                      paadhams.map((paadham, index) => {
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{paadham.name}</td>
                            <td>{paadham.isActive ? "TRUE" : "FALSE"}</td>
                            <td>
                              <i
                                className="fa fa-pencil btn btn-sm"
                                onClick={() => handleEdit(paadham)}
                              ></i>
                              <i
                                className="fa fa-trash btn btn-sm"
                                onClick={() => handleDelete(paadham.id)}
                              ></i>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr className="footable-empty text-center">
                        <td colSpan={3}>Nothing Found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className="aiz-pagination"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FormModel
        {...{
          setPaadhams,
          initial,
          setInitial,
          modalShow,
          setModalShow,
        }}
      />
    </div>
  );
}

export default Paadham;
